module.exports = __webpack_public_path__ + "static/img/jb.580fbf3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/wz/jb.png
// module id = aOFu
// module chunks = 1